module.exports = __webpack_public_path__ + "static/media/illustration-crescimento-pessoal.e4e1fcd5.svg";